import { DictValue } from '@/shared';

const REAL_ESTATE_OBJECTS_WITH_LAND = new Set<DictValue>(['HOUSE_WITH_LAND', 'TOWNHOUSE_WITH_LAND']);

/** Стоимость земельного участка есть только у объектов с участком, для остальных в API передаётся `land_amount: null` */
export function isRealEstateObjectWithLand(realEstateObject: DictValue | null | undefined): boolean {
  return realEstateObject != null && REAL_ESTATE_OBJECTS_WITH_LAND.has(realEstateObject);
}
